import { createSelector } from '@reduxjs/toolkit';
import { selectAvailableBanks } from './selectAvailableBanks';

export const selectBanksLogos = createSelector(selectAvailableBanks, state => {
  return state.reduce((acc: string[], { logoUrl }) => {
    acc.push(logoUrl);

    return acc;
  }, []);
});
